export const LOCATOR_URL =
  'https://gisportal.horrycounty.org/server/rest/services/Locators/County_Locator/GeocodeServer'

export const ROADS_NAMELAYER_URL =
  'https://www.horrycountysc.gov/gisweb/rest/services/Public/Streets/MapServer/0'
export const ROADS_LAYER_URL =
  'https://www.horrycountysc.gov/gisweb/rest/services/Public/Streets/MapServer/1'

export const HORRY_STREETS_MAP =
  'https://www.horrycountysc.gov/gisweb/rest/services/Public/Streets/MapServer'
export const HORRY_ELECTRIC_OUTAGES_LAYER =
  'https://portal.horryelectric.com/gis_services/rest/services/Internal/OMS/MapServer'

export const PROXY_URL = 'https://www.horrycountysc.gov/apps/proxy/proxy.ashx'

export const TRAFFIC_LAYER_URL =
  'https://traffic.arcgis.com/arcgis/rest/services/World/Traffic/MapServer'
